import { useEffect, useRef, useState } from "react";
import ApiCall from "../../Apicall/ApiCall";

// Reading a deal's clock from the server. Kept apart from dealClock.js on purpose: that module is
// pure (formatting and a ticking hook) and is imported by presentation that must stay testable
// without pulling in the API client, which is ESM and cannot be loaded by this project's Jest.

// GetDealStatus deliberately records no activity, unlike GetContractMainById and Heartbeat, so
// this may be polled freely: a poll can never be mistaken for the user being active and so keep
// an abandoned deal alive for ever.
export async function fetchDealStatus(contractId) {
  const res = await ApiCall({
    url: "/ContractMain/GetDealStatus",
    method: "GET",
    params: { Id: contractId },
  });
  return res?.data?.result || res?.result || null;
}

// Polls a deal's status and keeps the latest reading together with the moment it was taken.
export function useDealStatus(contractId, pollMs = 15000) {
  const [status, setStatus] = useState(null);
  const alive = useRef(true);
  useEffect(() => {
    alive.current = true;
    if (!contractId) {
      setStatus(null);
      return undefined;
    }
    const read = async () => {
      try {
        const next = await fetchDealStatus(contractId);
        if (alive.current && next) setStatus({ ...next, readAt: Date.now() });
      } catch (_) {
        /* transient: the next tick tries again */
      }
    };
    read();
    const id = setInterval(read, pollMs);
    return () => {
      alive.current = false;
      clearInterval(id);
    };
  }, [contractId, pollMs]);
  return status;
}
